export default __webpack_public_path__ + "static/media/serverpoint-white.9b4429f5.svg";